import { SubscriptionPlan } from '@core/models/billing/subscription-plan';
import { EnvironmentConfigType } from './environment-config-type';
import {
    APP,
    BILLING,
    DELIVERIES,
    DEVSUPPORT,
    ERROR,
    LIVEVIEW,
    LOCATIONS,
    LOGIN,
    PASSWORD_RESET,
    PASSWORD_VALIDATION_REQUEST,
    PASSWORD_VALIDATION_SUBMIT,
    PROFILE,
    REPORTS
} from '@core/router/app-states';

export const COMMON_CONFIG: {
    settings: Partial<EnvironmentConfigType['settings']>;
    routes: EnvironmentConfigType['routes'];
} = {
    settings: {
        referrals: {
            planId: SubscriptionPlan.LOC_YR_PREM_REFERRAL,
        },
        plans: {
            'tier.free': {
                month: {
                    price: 0,
                },
                year: {
                    price: 0,
                },
                restrictions: {
                    'cloud-storage': 28,
                    'report-storage': 28,
                },
            },
            'tier.starter': {
                month: {
                    planId: SubscriptionPlan.LOC_MO_STAR_DEFAULT,
                    price: 1599,
                },
                year: {
                    planId: SubscriptionPlan.LOC_YR_STAR_DEFAULT,
                    price: 1299,
                    totalPrice: 15588,
                },
                restrictions: {
                    'cloud-storage': 365,
                    'report-storage': 365,
                },
            },
            'tier.premium': {
                month: {
                    planId: SubscriptionPlan.LOC_MO_PREM_DEFAULT,
                    price: 3999,
                },
                year: {
                    planId: SubscriptionPlan.LOC_YR_PREM_DEFAULT,
                    price: 3399,
                    totalPrice: 40788,
                },
                restrictions: {
                    'cloud-storage': 2555,
                    'report-storage': 2555,
                },
            },
            'tier.enterprise': {
                month: {
                    price: 3999,
                },
                year: {
                    price: 3399,
                },
                restrictions: {
                    'cloud-storage': 2555,
                    'report-storage': 2555,
                },
            },
        },
    },
    routes: {
        public: [
            APP,
            LOGIN,
            'activation',
            PASSWORD_VALIDATION_REQUEST,
            PASSWORD_VALIDATION_SUBMIT,
            PASSWORD_RESET,
            'signup', // => this is 'REGISTRATION'
            ERROR
        ],
        employer: [
            APP,
            PROFILE,
            DELIVERIES,
            LIVEVIEW,
            REPORTS,
            BILLING,
            LOCATIONS,
            ERROR
        ],
        support: [
            DEVSUPPORT
        ]
    },
};
